import React, { useContext } from 'react';
import { getContext } from 'common';
import { TreeNodeContext, TreeBranchContext, TreeContext } from './';
import Styled from './styles';

export interface TreeTextProps extends React.ComponentPropsWithRef<'div'> {
  /** Item displayed in the TreeNode or TreeBranch. */
  children: React.ReactNode;
}

/** Text item to display in a Tree. Any other props will be provided to the root element. */
const TreeText = React.forwardRef<HTMLElement, TreeTextProps>((props: TreeTextProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    ...otherProps
  } = props;
  const { style: propsStyle, ...restOfOtherProps } = otherProps;
  const treeContext = useContext(TreeContext);
  const treeNodeContext = useContext(TreeNodeContext);
  const treeBranchContext = useContext(TreeBranchContext);
  // if there is no theme passed in the context, use global tree theme
  const resolvedTheme = treeContext.theme || theme.TREE;
  // when there is no theme passed in the context, this component is used by the Tree filtering component
  const TEXT_STYLE = {
    color: treeContext.theme ? undefined : theme.TREE.filterText,
  };
  return (
    <Styled.TreeText
      ref={ref}
      RTL={RTL}
      style={{ ...TEXT_STYLE, ...propsStyle }}
      $theme={resolvedTheme}
      $truncateListText={treeContext.truncateListText}
      level={treeNodeContext.level}
      error={treeNodeContext.error || treeBranchContext.error}
      disabled={treeNodeContext.disabled || treeBranchContext.disabled}
      selected={treeNodeContext.selected || treeBranchContext.selected}
      aria-selected={treeNodeContext.selected || treeBranchContext.selected}
      aria-disabled={treeNodeContext.disabled || treeBranchContext.disabled}
      {...restOfOtherProps}
    >
      {children}
    </Styled.TreeText>
  );
}));

TreeText.displayName = 'TreeText';

export { TreeText as default };